// ─── Cost helpers shared by AssetCard and AssetTeamPanel ─────────────────────

export const formatCost = amount => (amount != null ? `$${Number(amount).toFixed(2)}` : '—')

// A problem's cost is its final (actual) cost once known, otherwise the estimate
export const problemCost = problem => problem.actualCost ?? problem.estimatedCost ?? 0

// Maintenance cost totals only count finalized (actual) costs, not open estimates
export const sumMaintenanceCost = problems => (problems ?? []).reduce((sum, p) => sum + (p.actualCost ?? 0), 0)
